export const TARGETED_DB_FLASH = {
  START: 'START_TARGETED_DB_FLASH',
  COMPLETE: 'COMPLETE_TARGETED_DB_FLASH',
  FAIL: 'FAIL_TARGETED_DB_FLASH',
}
